/* eslint-disable semi */
/* eslint-disable arrow-body-style */
export default (players) => {
  if (players.length === 0) {
    return '';
  }
  return `
  <div class="" style="position: relative; background: linear-gradient(#1c1c1c,#d9bdaa); width: 100%; max-width: 900px; padding: 0; border-radius: 10px;">
    <div class="d-flex justify-content-between align-items-center mb-3" style="background: linear-gradient(#1c1c1c,#d9bdaa); border-radius: 10px 10px 0 0; opacity: 1; height: 44px; padding-left: 26px; padding-right: 50px;    border-top-left-radius: 10px;     border-top-right-radius: 10px;">
      <div>Add Player</div>
      <div class="btn-primary js-action-add-to-team-member">Add</div>
    </div>
    <div class="row" style="max-height: 550px; overflow: auto; padding: 20px;">
    ${players.map(item => (`
      <div class="col-6 col-lg-3 mb-3 style-wrapper">
        <label class="player-list__item d-flex flex-column product-item" for="new-position${item.nft_id}">
          <div class="badge-area-2">
            <div class="${item.generation === 2 ? 'badge-product-sale2' : 'badge-product-sale'}">
                <span class="new" ${item.generation === 2 ? 'style="background: #5c7f68"' : ''}>${item.generation === 2 ? 'Free' : 'Gen1'}</span>
                ${item.generation === 1 && item.nft_id < 3278 ? '<span class="percent"  >AVAX</span>' : item.generation === 1 ? '<span class="percent">CHZ</span>' : ''}
            </div>
          </div>
          <input name="new-position" class="js-new-position" type="radio" data-generation="${item.generation}" id="new-position${item.nft_id}" value=${item.nft_id}" />
          <div class="player-list__avatar product-thumb">
            <div class="player-image">
              <img src="${item.image}" ${item.generation == 2 ? 'style="background-color:#ffdf00dd"' : ''} />
            </div>
            <div class="d-flex" style="font-size: 12px; left: 5px; position: absolute; top: 5px;">
              ${item.positions.map(position => (`
                <div class="d-flex align-items-center justify-content-center" style="border: 1px solid #ffffff;  width: 25px; height: 25px; font-size: 10px; margin-right: 2px; border-radius: 50%;">
                  ${position}
                </div>

              `)).join('')}
                <div class="d-flex align-items-center justify-content-center" style="border: 1px solid #ffffff;  width: 25px; height: 25px; font-size: 10px; margin-right: 2px; border-radius: 50%;">
              ${item.overall}
            </div>
            </div>
          </div>
          <div class="player-list__label">
            <div class="mb-1 d-flex align-items-center justify-content-between">
              <div><a href="${item.seo}" target="_blank">${item.name}</a></div>
              <div>
                ${item.star_count >= 1 ? '<i class="icofont-star"></i>' : ''}
                ${item.star_count >= 2 ? '<i class="icofont-star"></i>' : ''}
                ${item.star_count >= 3 ? '<i class="icofont-star"></i>' : ''}
                ${item.star_count >= 4 ? '<i class="icofont-star"></i>' : ''}
              </div>
            </div>
          </div>
        </label>
      </div>
    `)).join('')}
    </div>
  </div>

    <style>
     .style-wrapper {
        display: flex;
    }

    .badge-area-show {
        width: 500px;
        height: 500px;
        margin: 0 auto;
        background: #666;
        position: relative;
    }

    .bagde-flag-wrap {
        position: absolute;
        top: 20px;
        left: -12px;
    }

    .bagde-flag-wrap::before {
        content: "";
        position: absolute;
        top: 35px;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 12px 12px 0;
        border-color: transparent #ecb41c transparent transparent;
    }

    .bagde-flag {
        text-transform: capitalize;
        color: #ffffff;
        background: #ecb41c;
        letter-spacing: 0;
        font-size: 14px;
        line-height: 15px;
        font-weight: 600;
        padding: 10px 15px;
        display: block;
        text-decoration: none;
    }


    .badge-product-sale {
        display: table;
        position: absolute;
        text-align: center;
        top: 30px;
        right: -13px;
        z-index: 2;
        min-width: 100px;
        -webkit-transform: rotate(90deg);
        -moz-transform: rotate(90deg);
        -ms-transform: rotate(90deg);
        transform: rotate(90deg);
    }

    .badge-product-sale2 {
        display: table;
        position: absolute;
        text-align: center;
        top: 30px;
        right: -13px;
        z-index: 2;
        min-width: 100px;
        -webkit-transform: rotate(90deg);
        -moz-transform: rotate(90deg);
        -ms-transform: rotate(90deg);
        transform: rotate(90deg);
    }

    .badge-product-sale span {
        position: relative;
        background: #bc8246;
        color: #fff;
        float: left;
        font-size: 11px;
        font-weight: 400;
        height: 28px;
        line-height: 28px;
        padding: 0 10px;
        text-align: center;
        text-transform: uppercase;
        font-weight: 500;
        letter-spacing: 0.5px;
        min-width: 50px;
        border-radius: 0;
        min-height: auto;
        border: 0;
    }

    .badge-product-sale2 span {
        position: relative;
        background: #bc8246;
        color: #fff;
        float: left;
        font-size: 11px;
        font-weight: 400;
        height: 28px;
        line-height: 28px;
        padding: 0 10px;
        text-align: center;
        text-transform: uppercase;
        font-weight: 500;
        letter-spacing: 0.5px;
        min-width: 50px;
        border-radius: 0;
        min-height: auto;
        border: 0;
    }

    .badge-product-sale span.percent {
        background: #201f1f;
    }

    .badge-product-sale2 span.percent {
        background: #201f1f;
    }

    .badge-product-sale span::before {
        border: 5px solid #bc8246;
        border-color: #bc8246 transparent transparent #bc8246;
        border-width: 9px 5px;
        position: absolute;
        right: -9px;
        top: 0;
        content: "";
        z-index: 1;
    }
    .badge-product-sale2 span::before {
        border: 5px solid #5c7f68;
        border-color: #5c7f68 transparent transparent #5c7f68;
        border-width: 9px 5px;
        position: absolute;
        right: -9px;
        top: 0;
        content: "";
        z-index: 1;
    }

    .badge-product-sale2 span::after {
        border: 5px solid #5c7f68;
        border-color: transparent transparent #5c7f68 #5c7f68;
        border-width: 10px 5px;
        position: absolute;
        right: -9px;
        bottom: 0;
        content: "";
        z-index: 1;
    }
    .badge-product-sale span::after {
        border: 5px solid #bc8246;
        border-color: transparent transparent #bc8246 #bc8246;
        border-width: 10px 5px;
        position: absolute;
        right: -9px;
        bottom: 0;
        content: "";
        z-index: 1;
    }

    .badge-product-sale2 span.percent::before {
        border: 5px solid #201f1f;
        border-color: #201f1f transparent transparent #201f1f;
        border-width: 9px 5px;
    }

    .badge-product-sale2 span.percent::after {
        border: 5px solid #201f1f;
        border-color: transparent transparent #201f1f #201f1f;
        border-width: 10px 5px;
    }

    .badge-product-sale span.percent::before {
        border: 5px solid #201f1f;
        border-color: #201f1f transparent transparent #201f1f;
        border-width: 9px 5px;
    }

    .badge-product-sale span.percent::after {
        border: 5px solid #201f1f;
        border-color: transparent transparent #201f1f #201f1f;
        border-width: 10px 5px;
    }
</style>


  `
};
